<template>
  <div class="main">
    <Menu mode="horizontal" theme="dark" :active-name="active">
      <Menu-item
        @click.native="toPath(i, n)"
        v-for="(i, n) in menuItems"
        :key="n"
        :name="i.type"
      >
        <div class="index" v-if="i.type == 1">
          <!-- <span class="index-icon"><Icon type="md-menu" /></span> -->
          首页
        </div>
        <div class="other" v-else>
          {{ i.name }}
        </div>
      </Menu-item>
      <!-- <Menu-item name="6">
        <Icon type="md-phone-portrait" />
        <div class="phone">关联后台手机号</div>
      </Menu-item> -->
    </Menu>
    <div class="person">
      <Dropdown @on-click="handleClick">
        {{ userInfo.name }}
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="set">帮助中心</DropdownItem>
          <DropdownItem name="account">账户中心</DropdownItem>
          <DropdownItem name="logout">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>
<script>
import {mapState, mapMutations} from "vuex";
import {menuList} from '@/assets/global/nav.js'

export default {
  data() {
    return {
      active: 1,
      menuItems: [],
      theme1: "light",
    };
  },
  computed: {
    ...mapState({
      userInfo(state) {
        return state.user.userInfo;
      }
    }),
    actives() {
      return active
    }
  },
  watch: {
    active: {
      handler: function (val) {
        if (val) {
          sessionStorage.setItem('active', Number(val))
          this.active = Number(val)
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getWebInfo()
  },
  methods: {
    ...mapMutations(["setBuisnessToken", "setAuthList"]),
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "account":
          this.$store.commit('global/SET_LABEL_MSG_ACCOUNT', '个人账户')
          this.$router.push("/businessManagement");
          break;
        case "set":
          this.$router.replace({name: "StatisticalLearning"});
          break;
        case "Favorite":
          this.$router.replace({name: "Favorite"});
          break;
        case "HistoricalRecord":
          this.$router.replace({name: "HistoricalRecord"});
          break;
      }
    },
    toPath(i, n) {
      // 改变左侧导航配置
      //     'examMennu': [
      //   {name: '考试测评', type: '3-1', icon: 'ios-paper-outline', url: '/myExam'},
      // ],
      // 'eshopMennu': [
      //   {name: '网上商城', type: '5-1', icon: 'ios-paper-outline', url: '/eShop'},
      // ],
      // 'personMennu'
      if (i.name == '首页') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[0])
      } else if (i.name == '爱学在线') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[1])
      } else if (i.name == '考试测评') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[2])
      } else if (i.name == '面授课程') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[3])
      } else if (i.name == '网上商城') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[4])
      } else if (i.name == '个人中心') {
        this.$store.commit('global/SET_LEFT_MENU', menuList[5])
      } else {
        this.$store.commit('global/SET_LEFT_MENU', menuList[0])
      }
      this.active = i.type
      sessionStorage.setItem('active', this.active)
      // console.log(this.active)
      this.$router.push({path: i.url})
    },
    logout() {
      this.setBuisnessToken("");
      // this.setUserInfo({})
      this.setAuthList([]);
      // this.$cookies.remove('ZONG_TOKEN')
      sessionStorage.removeItem("userInfo");
      localStorage.removeItem("tagNaveList");
      this.$router.replace({name: "Login"});
      // this.$axios.get("/admin/login/logout").then(res => {
      //   if (res.code == 1) {
      //     this.$Message.error(res.msg);
      //   } else {
      //     this.setBuisnessToken('');
      //     this.setAuthList([]);
      //     this.$router.replace({ name: "Login" });
      //   }
      // });
    },
    getWebInfo() {
      this.$axios
        .post('/app/auth/getWebInfo')
        .then((res) => {
          this.menuItems = [
            {name: "首页", type: 1, url: "/home"},
            {name: "爱学在线", type: 2, url: "/recordingCourse"},
            {name: "考试测评", type: 3, url: "/myExam"},
            {name: "面授课程", type: 4, url: "/faceCourse"},
            {name: "网上商城", type: 5, url: "/eShop"},
            {name: "个人中心", type: 6, url: "/businessManagement"}
          ];
          if (res.code == 1) {
            let face_switch = res.data.face_switch
            this.face_switch = face_switch
            if (face_switch == '2') {
              this.menuItems = this.menuItems.filter(item => item.type !== 4);
            }
            let active = sessionStorage.getItem('active')
            if (active) {
              this.active = active
            }
            if (face_switch == '2') {
              let arr = menuList[0]
              arr = arr.filter(item => item.type !== '1-5');
              menuList[0] = arr
            }
            this.$store.commit('global/SET_LEFT_MENU', menuList[this.active - 1])
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.main {
  position: relative;
  // width: 100vw;
  /deep/ .ivu-menu-dark {
    background: #4a4f53;
    color: #fff;
    font-size: 33px;
  }

  /deep/ .ivu-menu-item {
    font-size: 18px;
  }

  /deep/ .ivu-menu-item-active {
    background: #f4663a;
  }

  /deep/ .ivu-menu-item:nth-child(1) {
    margin-left: 100px;
  }

  /deep/ .ivu-menu-horizontal {
    height: 50px;
    line-height: 50px;
  }

  .person {
    position: absolute;
    top: 15px;
    right: 7vw;
    z-index: 1000;
    color: #fff;
    cursor: pointer;
  }

  .index {
    width: 12vw;
    text-align: center;

    .index-icon {
      display: inline-block;
      width: 12vw;
      // margin-left: -160px;
    }
  }

  .other {
    width: 9vw;
    text-align: center;
  }

  .phone {
    display: inline-block;
    position: relative;
    font-size: 15px;
    top: -5px;
  }
}
</style>
